/**
 * CSS class names (see design-system.css) with fixed border-radius.
 * Theme `--radius-*` comes from design tokens (`square` vs `rounded`); large surfaces
 * still use these utility classes where Tailwind radii need a stable override.
 */
export const CONTRACTOR_SURFACE_RADIUS_LG_CLASS =
  "contractor-surface-radius-lg";
export const CONTRACTOR_SURFACE_RADIUS_MD_CLASS =
  "contractor-surface-radius-md";
/** Wide form panel; radius is `0.5rem` + `overflow: visible` in design-system.css */
export const CONTRACTOR_SURFACE_QUOTE_SHELL_CLASS =
  "contractor-surface-quote-shell";
